import allEmojis from '@quicktools/emojis/data/all';

import CategoryPage from '../components/CategoryPage';
import Landing from '../components/Landing/Landing';

function Index() {
  return (
    <CategoryPage emojis={allEmojis} category="index">
      <Landing />
    </CategoryPage>
  );
}

export default Index;
